import style from './PrimaryButton.module.scss';

export function PrimaryButton({
    text,
    fluid = true,
    onClick,
    isLoading = false,
    trailing,
    leading,
    backgroundColor,
    textColor,
    className
}) {
    if (isLoading) {
        return <div className={style.loader}>Loading...</div>;
    }

    return (
        <button
            onClick={onClick}
            className={`${style.primaryButton} ${fluid ? style.fluid : ''} ${className || ''}`}
            style={{
                backgroundColor: backgroundColor || 'hsl(285, 100%, 58%)', // Your purple accent color
                color: textColor || '#ffffff'
            }}
        >
            <div className={style.content}>
                {leading && <span className={style.leading}>{leading}</span>}
                <span className={style.text}>{text}</span>
                {trailing && <span className={style.trailing}>{trailing}</span>}
            </div>
        </button>
    );
} 